/**
 * @generated SignedSource<<4499725ac4d20c7c66ec15116bd9fa12>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterTableSize_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useMeasurementUnit_user">;
  readonly " $fragmentType": "SbSharedRefineMenuFilterTableSize_user";
};
export type SbSharedRefineMenuFilterTableSize_user$key = {
  readonly " $data"?: SbSharedRefineMenuFilterTableSize_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuFilterTableSize_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuFilterTableSize_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useMeasurementUnit_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "2c438f7d10d2e103584e9b04db5ab9ad";

export default node;
